import { RemoveRedEye } from '@mui/icons-material';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  InputProps,
  Typography
} from '@mui/material';
import _ from 'lodash';

import React, { useState } from 'react';



export type StyledTextFieldProps = {
  validationErrorMessage?: string;
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

export const FC = (props: StyledTextFieldProps & InputProps) => {
  const [
    showPassword,
    setShowPassword
  ] = useState(false);
  return (
    <FormControl
      fullWidth
      required={props.required}
      error={props.validationErrorMessage && props.validationErrorMessage?.length > 1 ? true : false}
    >
      <FormLabel>
        <Typography
          variant='formLabel'
        >
          {props.label}
        </Typography>
      </FormLabel>
      <Input

        color={props.color}
        fullWidth
        disabled={props.disabled}
        onKeyDown={(val) => {
          if (val.code === 'Enter' && val.metaKey) {
            // val.preventDefault();
            // props.handleSubmit();
          }
          if (val.code === 'Enter') {
            val.stopPropagation();
          }

        }}
        disableUnderline
        multiline={props.multiline ?? props.minRows ? true : false}
        minRows={props.minRows ? props.minRows : 1}
        required={props.required}
        value={props.value}
        placeholder={props.placeholder ?? ''}
        name={props.name}
        type={showPassword ? 'text' : props.type}
        onClick={(e) => {
          e.stopPropagation();
        }}
        startAdornment={props.startAdornment ? props.startAdornment : undefined}
        endAdornment={props.type === 'password'
          ? (
            <RemoveRedEye onClick={(e) => {
              e.stopPropagation();
              setShowPassword((prev) => !prev);
            }}
            />
          )
          : props.endAdornment ? props.endAdornment : undefined}
        onChange={(e) => {
          e.stopPropagation();
          props.onChange(e);
        }}
      />{
        props.validationErrorMessage && props.validationErrorMessage.length > 1 && _.toString(props.value).length > 0
          ? (
            <FormHelperText variant='standard'>
              {props.validationErrorMessage}
            </FormHelperText>
          )
          : (<></>)
      }
    </FormControl>
  );
};
